import { render, staticRenderFns } from "./NotificationPanelItemGroups.vue?vue&type=template&id=569384c8&scoped=true"
import script from "./NotificationPanelItemGroups.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationPanelItemGroups.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./NotificationPanelItemGroups.vue?vue&type=style&index=0&id=569384c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569384c8",
  null
  
)

export default component.exports